import FormattedMessage from 'I18n/components/FormattedMessage';
import { SortTableAscIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { COMPARE_PLANS_LINK } from '../constants/ErrorBoundaryNames';
import { withErrorBoundary } from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComparePlansLink = () => {
  const scrollToFeatureTable = () => {
    const element = document.querySelector('#feature-table');
    const fallback = document.querySelector('table');
    (element || fallback).scrollIntoView({
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    marginBlockStart: "500",
    children: [/*#__PURE__*/_jsx(Link, {
      onClick: scrollToFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgradePages.comparePlan"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(SortTableAscIcon, {
        size: "600",
        color: "text-interactive-default"
      })
    })]
  });
};
export default withErrorBoundary(ComparePlansLink, {
  boundaryName: COMPARE_PLANS_LINK
});